<template>
    <div class="csv-upload-zone">
        <FileUpload
            mode="advanced"
            :custom-upload="true"
            accept=".csv"
            :maxFileSize="10000000"
            @select="onFileSelect"
            @error="onError"
            choose-label="Загрузить из файла"
        >
            <template #empty>
                <div class="upload-placeholder">
                    <i class="pi pi-upload upload-icon"></i>
                    <p>Перетащите CSV-файл сюда или нажмите для выбора</p>
                    <div class="format-info">
                        <span>Формат: CSV, разделитель «;» (точка с запятой)</span>
                        <span>Кодировка: UTF-8</span>
                        <span>Первая строка — названия столбцов</span>
                    </div>
                </div>
            </template>
        </FileUpload>
    </div>
</template>

<script>
import api from "@/libs/api";

export default {
    name: "CsvUploadZone",
    props: {
        projectId: {
            type: Number,
            required: true
        },
        hasData: {
            type: Boolean,
            default: false
        }
    },
    emits: ['uploaded', 'needs-confirmation'],
    methods: {
        async onFileSelect(event) {
            const file = event.files[0];
            if (!file) return;

            try {
                await api.uploadDataFile(this.projectId, [file]);
                this.$toast.add({
                    severity: 'success',
                    summary: 'Успешно',
                    detail: 'Данные загружены',
                    life: 3000
                });
                this.$emit('uploaded');
            } catch (err) {
                if (err.response && err.response.data.error === 'data_replacement_requires_confirmation') {
                    this.$emit('needs-confirmation', {
                        currentRowCount: err.response.data.current_row_count,
                        file: file
                    });
                } else if (err.response && err.response.data.error === 'invalid_csv_format') {
                    this.showFormatError(err.response.data);
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Ошибка загрузки',
                        detail: 'Не удалось загрузить файл. Попробуйте ещё раз.',
                        life: 5000
                    });
                }
            }
        },
        showFormatError(errorData) {
            let detail = 'Проверьте формат файла.';

            switch (errorData.detail) {
                case 'no_semicolons':
                    detail = 'Файл не содержит разделителей «;». Убедитесь, что при сохранении CSV в Excel выбран формат «CSV (разделители — точки с запятой)».';
                    break;
                case 'empty_file':
                    detail = 'Загруженный файл не содержит данных.';
                    break;
                case 'headers_only':
                    detail = 'Файл содержит только заголовки, но ни одной строки данных.';
                    break;
                case 'encoding':
                    detail = 'Файл содержит нечитаемые символы. Сохраните файл в кодировке UTF-8.';
                    break;
            }

            this.$toast.add({
                severity: 'error',
                summary: 'Неверный формат файла',
                detail: detail,
                life: 7000
            });
        },
        onError() {
            this.$toast.add({
                severity: 'error',
                summary: 'Ошибка',
                detail: 'Ошибка при выборе файла',
                life: 5000
            });
        }
    }
}
</script>

<style scoped>
.csv-upload-zone {
    width: 100%;
}

.upload-placeholder {
    padding: 20px;
    text-align: center;
    color: #6c757d;
}

.upload-icon {
    font-size: 2rem;
    margin-bottom: 12px;
    color: #3b82f6;
}

.upload-placeholder p {
    margin: 0 0 12px 0;
    font-size: 0.95rem;
}

.format-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 0.8rem;
    color: #adb5bd;
}

:deep(.p-fileupload) {
    width: 100%;
}
</style>
